module.exports = __webpack_public_path__ + "fonts/AvenirNextLTPro-Regular.b5ed9330.otf";